import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

const Signup = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
  });
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("https://hrgf.salepatner.com/api/register/", formData);
      if (res.data.tokens?.access)
        localStorage.setItem("access", res.data.tokens.access);
      localStorage.setItem("username", res.data.username || formData.username);
      navigate("/home");
    } catch (error) {
      setMessage(error.response?.data?.error || "Something went wrong");
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 relative">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-white/40 backdrop-blur-sm"></div>

      {/* Signup container */}
      <div className="relative z-10 flex flex-col md:flex-row w-11/12 max-w-5xl bg-white shadow-2xl rounded-3xl overflow-hidden border border-gray-200">

        {/* LEFT SIDE - Info Section */}
        <div className="hidden md:flex flex-col justify-center items-center w-1/2 bg-gradient-to-br from-gray-800 via-gray-700 to-gray-900 text-white p-10">
          <img
            src="https://cdn-icons-png.flaticon.com/512/1040/1040230.png"
            alt="Join Us"
            className="w-32 mb-6 opacity-90"
          />
          <h2 className="text-3xl font-bold mb-4 text-center">
            Join <span className="text-yellow-300">HRGF</span> Today!
          </h2>
          <p className="text-center mb-8 opacity-90 leading-relaxed">
          
          </p>
          <Link
            to="/login"
            className="border border-white px-8 py-2 rounded-full text-white hover:bg-white hover:text-gray-900 transition font-semibold"
          >
            LOGIN
          </Link>
        </div>

        {/* RIGHT SIDE - Signup Form */}
        <div className="w-full md:w-1/2 bg-white p-10 md:p-14 flex flex-col justify-center items-center">
          <h2 className="text-3xl font-extrabold text-gray-800 mb-2">
            Create Your Account
          </h2>
          <p className="text-gray-500 mb-8">It only takes a minute to get started</p>

          <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-5">
            <input
              type="text"
              placeholder="Username"
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gray-500"
              value={formData.username}
              onChange={(e) =>
                setFormData({ ...formData, username: e.target.value })
              }
            />

            <input
              type="email"
              placeholder="Email"
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gray-500"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />

            <input
              type="password"
              placeholder="Password"
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gray-500"
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
            />

            {message && (
              <p className="text-red-500 text-sm font-medium">{message}</p>
            )}

            <button
              type="submit"
              className="w-full bg-gray-800 text-white py-3 rounded-lg font-semibold hover:bg-gray-900 transition shadow-md"
            >
              Sign Up
            </button>
          </form>

          {/* Divider */}
          <div className="flex items-center w-full max-w-sm my-6">
            <div className="flex-1 h-px bg-gray-300"></div>
            <p className="text-gray-400 text-sm px-3">or</p>
            <div className="flex-1 h-px bg-gray-300"></div>
          </div>

          {/* Google Signup */}
          <button className="w-full max-w-sm border border-gray-300 rounded-lg py-3 flex items-center justify-center gap-2 hover:bg-gray-50 transition">
            <img
              src="https://www.svgrepo.com/show/355037/google.svg"
              alt="Google"
              className="w-5 h-5"
            />
            <span className="text-gray-700 font-medium">
              Sign up with Google
            </span>
          </button>

          {/* Login Redirect */}
          <p className="text-gray-500 text-sm mt-6">
            Already have an account?{" "}
            <Link
              to="/login"
              className="text-gray-800 font-semibold hover:underline"
            >
              Login here
            </Link>
          </p>

          <div className="flex justify-between text-sm text-gray-400 mt-6 w-full max-w-sm">
            <span>Privacy Policy</span>
            <span>Terms & Conditions</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
